/** Browser-provided Global Privacy Control signal (Sec-GPC in JavaScript). */
export const isGlobalPrivacyControlEnabled = (navigatorLike: unknown): boolean => {
  if (typeof navigatorLike !== 'object' || navigatorLike === null) return false;

  return (navigatorLike as { globalPrivacyControl?: unknown }).globalPrivacyControl === true;
};

/** Clinic-configured analytics are optional and must yield to the browser's GPC signal. */
export const shouldInitializeOptionalAnalytics = (
  trackingId: string | null | undefined,
  navigatorLike: unknown
): boolean => !!trackingId && !isGlobalPrivacyControlEnabled(navigatorLike);
